class OptionButtons extends HTMLElement {
	constructor() {
		super();
		this.optionBlocks = Array.from(this.querySelectorAll('.js-product-option'));
		this.variants = this.getVariantData();

		this.container = this.closest('.js-product-container') || this.closest('.zd-product') || document;
		this.form = this.container.querySelector('product-form form');
		this.variantIdInput = this.form?.querySelector('[name="id"]');
		this.bindEvents();

		this.updateOptionsAvailability();
		this.updateVariant();
	}

	bindEvents() {
		this.addEventListener('click', (event) => {
			const sizeToggle = event.target.closest('.js-toggle-size a');
			if (sizeToggle) {
				event.preventDefault();
				this.handleSizeToggle(sizeToggle);
				return;
			}

			const optionLink = event.target.closest('[data-value]');
			if (!optionLink) return;

			if (optionLink.classList.contains('unavailable') && optionLink.classList.contains('is-disabled')) {
				event.preventDefault();
				return;
			}

			event.preventDefault();
			this.handleOptionClick(optionLink);
		});
	}

	handleSizeToggle(link) {
		const block = link.closest('.js-product-option');
		if (!block) return;

		block.querySelectorAll('.js-toggle-size a').forEach((item) => {
			item.classList.toggle('active', item === link);
		});

		const tab = link.dataset.tab === 'eu' ? 'eu' : 'us';
		block.querySelectorAll('ul[data-size]').forEach((list) => {
			list.classList.toggle('show', list.dataset.size === tab);
		});
	}

	handleOptionClick(link) {
		const block = link.closest('.js-product-option');
		if (!block) return;

		const value = link.dataset.value;
		block.querySelectorAll('[data-value]').forEach((item) => {
			item.classList.toggle('active', item.dataset.value === value);
		});

		const valueLabel = block.querySelector('.js-option-value');
		if (valueLabel) {
			valueLabel.textContent = value;
		}

		const selectedOptions = this.getSelectedOptions();

		const matchingVariant = this.variants.find(variant => {
			const variantOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
			return variantOptions.every((opt, index) => selectedOptions[index] === opt);
		});

		const changedIndex = parseInt(block.dataset.index, 10);
		if (changedIndex === 0) {
			this.selectFirstAvailableVariantForOption(block, value);
		} else if (!matchingVariant) {
			this.selectFirstAvailableVariantForOption(block, value);
		}

		this.updateOptionsAvailability();
		this.updateVariant();
	}

	selectFirstAvailableVariantForOption(changedBlock, changedValue) {
		const changedIndex = parseInt(changedBlock.dataset.index, 10);
		const validVariant = this.variants.find(variant => {
			const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
			return options[changedIndex] === changedValue && variant.available;
		}) || this.variants.find(variant => {
			const options = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
			return options[changedIndex] === changedValue;
		});

		if (validVariant) {
			const options = validVariant.options || [validVariant.option1, validVariant.option2, validVariant.option3].filter(Boolean);

			this.optionBlocks.forEach((block) => {
				const bIndex = parseInt(block.dataset.index, 10);
				if (bIndex !== changedIndex) {
					const newValue = options[bIndex];

					block.querySelectorAll('[data-value]').forEach(btn => {
						btn.classList.toggle('active', btn.dataset.value === newValue);
					});

					const label = block.querySelector('.js-option-value');
					if (label) label.textContent = newValue;
				}
			});
		}
	}

	updateOptionsAvailability() {
		if (!this.variants.length) return;
		const selectedOptions = this.getSelectedOptions();

		this.optionBlocks.forEach((block) => {
			const actualIndex = parseInt(block.dataset.index, 10);
			const optionLinks = block.querySelectorAll('[data-value]');

			const relevantVariants = this.variants.filter(variant => {
				const vOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);

				// Перевіряємо тільки ті опції, які стоять ДО поточної в логіці Shopify
				for (let i = 0; i < actualIndex; i++) {
					if (vOptions[i] !== selectedOptions[i]) return false;
				}
				return true;
			});

			optionLinks.forEach(link => {
				const value = link.dataset.value;
				let hasVariant = false;
				let hasInStock = false;

				const matchingVariants = relevantVariants.filter(variant => {
					const vOptions = variant.options || [variant.option1, variant.option2, variant.option3].filter(Boolean);
					return vOptions[actualIndex] === value;
				});

				hasVariant = matchingVariants.length > 0;
				hasInStock = matchingVariants.some(v => v.available);

				if (!hasVariant) {
					link.classList.add('unavailable', 'is-disabled');
					link.classList.remove('sold-out');
					link.dataset.disabled = 'true';
				} else if (!hasInStock) {
					link.classList.add('is-disabled');
					link.classList.remove('unavailable', 'sold-out');
					link.dataset.disabled = 'true';
				} else {
					link.classList.remove('unavailable', 'sold-out', 'is-disabled');
					link.dataset.disabled = 'false';
				}
			});
		});
	}

	updateVariant() {
		const selected = this.getSelectedOptions();
		const variant = this.variants.find((item) => {
			const options = item.options || [item.option1, item.option2, item.option3].filter(Boolean);
			return options.every((opt, index) => selected[index] === opt);
		});

		if (!variant) return;

		if (this.currentVariant && this.currentVariant.id === variant.id) return;
		this.currentVariant = variant;

		this.updateUrl();
		this.updateContent();
	}

	getSelectedOptions() {
		const optionsArray = [];
		this.optionBlocks.forEach((block) => {
			const index = parseInt(block.dataset.index, 10);
			if (block.dataset.optionType === 'color') {
				const valueEl = block.querySelector('.js-option-value');
				optionsArray[index] = valueEl ? valueEl.textContent.trim() : null;
			} else {
				const active = block.querySelector('[data-value].active');
				optionsArray[index] = active ? active.dataset.value : null;
			}
		});
		return optionsArray;
	}

	updateUrl() {
		if (!this.currentVariant || !this.dataset.url) return;

		if (!this.isInitialized) {
			this.isInitialized = true;
			return;
		}

		const url = new URL(this.dataset.url, window.location.origin);
		url.searchParams.set('variant', this.currentVariant.id);
		window.history.replaceState({}, '', url);
	}

	async updateContent() {
		if (!this.currentVariant) return;

		if (this.variantIdInput) {
			this.variantIdInput.value = this.currentVariant.id;
			this.variantIdInput.disabled = false;
		}

		const sectionId = this.dataset.section;
		const productUrl = this.dataset.url;

		if(!sectionId || !productUrl) return;

		try {
			const url = new URL(productUrl, window.location.origin);
			url.searchParams.set('variant', this.currentVariant.id);
			url.searchParams.set('section_id', sectionId);

			const response = await fetch(url);
			const text = await response.text();
			const html = new DOMParser().parseFromString(text, 'text/html');

			this.updateElements(html);

			if (typeof initQuantity === 'function') {
				initQuantity(this.container);
			}

			const productForm = this.container.querySelector('product-form');
			if (productForm) {
				productForm.addButtons = productForm.querySelectorAll('button[name="add"]');
			}

		} catch (error) {
			console.error('Error updating product content:', error);
		}
	}

	updateElements(html) {
		const selectors = [
			{ selector: '[data-product-price]', method: 'innerHTML' },
			{ selector: '[data-product-status]', method: 'innerHTML' },
			{ selector: '[data-product-button]', method: 'innerHTML' },
			{ selector: '[data-product-qty]', method: 'innerHTML' },
			{ selector: '[data-sticky-variant-title]', method: 'innerHTML' },
			{ selector: '[data-sticky-button-container]', method: 'innerHTML' }
		];

		selectors.forEach(({ selector, method }) => {
			let destination;
			if (selector.includes('sticky')) {
				destination = document.querySelector(selector);
			} else {
				destination = this.container.querySelector(selector);
			}

			const source = html.querySelector(selector);

			if (destination && source) {
				if (method === 'innerHTML') {
					destination.innerHTML = source.innerHTML;
				} else {
					destination.outerHTML = source.outerHTML;
				}
			}
		});

		const productForm = this.container.querySelector('product-form');
		if (productForm && typeof productForm.bindStickyButton === 'function') {
			productForm.stickyButton = document.querySelector('.js-sticky-add-to-cart');
			productForm.bindStickyButton();
		}
	}

	getVariantData() {
		const variantData = this.querySelector('[type="application/json"]')?.textContent;
		if (!variantData) return [];
		try {
			return JSON.parse(variantData);
		} catch (error) {
			console.error('Failed to parse variant data:', error);
			return [];
		}
	}
}

customElements.define('option-buttons', OptionButtons);